import React from "react"
import { SecondaryButton } from "../../shared/Button"
import Heading from "../../shared/Heading"
import { ReactComponent as CalendarIcon } from "../../../icons/calendar.svg"
import { ReactComponent as PostIcon } from "../../../icons/post.svg"
import { ReactComponent as PlaylistIcon } from "../../../icons/playlist.svg"
import { new_event_path, new_playlist_path, new_post_path } from "../../../routes"

const MakeStuff: React.FC = () => {
  return (
    <>
      <Heading level={2} type="sectionHeader">
        Make Stuff
      </Heading>
      <div className="flex flex-col mb-6">
        <SecondaryButton
          to={new_event_path()}
          className="flex-1 mb-2"
          active={window.location.pathname === new_event_path()}
        >
          <CalendarIcon className="mr-2" />
          Create an Event
        </SecondaryButton>
        <SecondaryButton
          to={new_post_path()}
          className="flex-1 mb-2"
          active={window.location.pathname === new_post_path()}
        >
          <PostIcon className="mr-2" />
          Create a Post
        </SecondaryButton>
        <SecondaryButton
          to={new_playlist_path()}
          className="flex-1"
          active={window.location.pathname === new_playlist_path()}
        >
          <PlaylistIcon className="mr-2" />
          Create a Playlist
        </SecondaryButton>
      </div>
    </>
  )
}

export default MakeStuff
